<template>
  <div id="voting-rights">
    <v-card class="upload-dialog-card">
      <!-- Header -->
      <div class="dialog-header">
        <div class="header-content">
          <div class="header-icon">
            <v-icon color="white" size="22">mdi-file-upload</v-icon>
          </div>
          <div class="header-text">
            <h3 class="header-title">{{ pageTitle }}</h3>
            <p class="header-subtitle">Upload your document in PDF format</p>
          </div>
        </div>
        <v-btn icon dark small @click="closePrompt" class="close-btn">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </div>

      <v-card-text class="dialog-body">
        <v-form ref="form1" v-model="valid1" lazy-validation id="createForm">
          <!-- Sample Download Section -->
          <div class="sample-download-section">
            <v-icon color="#3a67b1" size="20">mdi-information</v-icon>
            <span class="sample-text">Download the</span>
            <a
              :href="SampleFilePath"
              target="_blank"
              download
              class="sample-link"
            >
              <v-icon small color="#3a67b1">mdi-download</v-icon>
              Sample Format
            </a>
            <span class="sample-text">before uploading</span>
          </div>

          <!-- File Upload Section -->
          <div class="upload-section">
            <div
              class="upload-dropzone"
              :class="{ 'has-file': UploadedFile && UploadedFile.name }"
              @click="$refs.fileInput.$el.querySelector('input').click()"
            >
              <div
                v-if="UploadedFile && UploadedFile.name"
                class="file-preview"
              >
                <div class="file-icon">
                  <v-icon color="#e53935" size="36">mdi-file-pdf-box</v-icon>
                </div>
                <div class="file-info">
                  <span class="file-name">{{ UploadedFile.name }}</span>
                  <span class="file-size">{{
                    formatFileSize(UploadedFile.size)
                  }}</span>
                </div>
                <v-btn
                  icon
                  small
                  color="error"
                  @click.stop="UploadedFile = {}"
                  class="remove-file-btn"
                >
                  <v-icon size="18">mdi-close-circle</v-icon>
                </v-btn>
              </div>
              <div v-else class="upload-placeholder">
                <div class="upload-icon">
                  <v-icon color="#3a67b1" size="40"
                    >mdi-cloud-upload-outline</v-icon
                  >
                </div>
                <p class="upload-text">Click to select PDF file</p>
                <p class="upload-hint">Only PDF files are accepted</p>
              </div>
            </div>
            <v-file-input
              ref="fileInput"
              :clearable="false"
              truncate-length="25"
              accept="application/pdf"
              v-model="UploadedFile"
              class="hidden-file-input"
              hide-details
            />
          </div>
        </v-form>
      </v-card-text>

      <!-- Footer -->
      <v-card-actions class="dialog-footer">
        <v-spacer></v-spacer>
        <v-btn @click="closePrompt" depressed class="action-btn cancel-btn">
          <v-icon left small>mdi-close</v-icon>
          Cancel
        </v-btn>
        <v-btn
          :disabled="!valid1 || !UploadedFile || !UploadedFile.name"
          @click.prevent="confirmAlert"
          :loading="SubmitFlag"
          depressed
          class="action-btn save-btn"
        >
          <v-icon left small>mdi-check</v-icon>
          Upload & Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>
<script>
import common from "@/view/Common.vue";
import companyConfig from "@/company_config.json";
import Swal from "sweetalert2";

export default {
  mixins: [common],
  props: {
    pageTitle: {
      required: true,
    },
    SampleFilePath: {
      required: false,
    },
  },
  data() {
    return {
      valid1: true,
      valid2: true,
      LoadingFlag: false,
      ResultFlag: false,
      SubmitFlag: false,

      UploadFlag: false,

      progessStart: 0,
      uploadPercentage: 0,

      rows: [],
      member: {},

      UploadedFile: {},

      DocumentTypeRules: [(v) => !!v || "Document Type is required"],
      DocumentType: "",
      DocumentTypeOptions: [],
      DocumentTypeOptionsLoading: false,
    };
  },
  methods: {
    formatFileSize(bytes) {
      if (!bytes) return "";
      if (bytes < 1024) return bytes + " B";
      if (bytes < 1048576) return (bytes / 1024).toFixed(1) + " KB";
      return (bytes / 1048576).toFixed(1) + " MB";
    },
    refreshPageData() {
      console.log("refreshPageData called");
      this.LoadingFlag = true;
      var server_url = companyConfig.apiURL;
      console.log("server_url = " + server_url);
    },

    resetForm() {
      console.log("resetForm called");
      this.$refs.form1.reset();
      this.closePrompt();
    },
    closePrompt() {
      console.log("closePrompt called");
      this.$emit("hideAddRecordPrompt", this.ResultFlag);
    },
    confirmAlert() {
      var validate1 = this.$refs.form1.validate();
      console.log("validate1=" + validate1);
      if (validate1) {
        Swal.fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: `Save`,
          confirmButtonColor: "#3085d6",
          cancelButtonText: `Cancel`,
          cancelButtonColor: "#d33",
        }).then((result) => {
          /* Read more about isConfirmed, isDenied below */
          if (result.isConfirmed) {
            this.submitForm();
          } else {
            this.sweetAlert("error", "You cancelled the process", true);
          }
        });
      } else {
        // this.toast("error", "Kindly fill the required fields", true);
      }
    },
    submitForm() {
      console.log("submitForm called");
      var validate1 = this.$refs.form1.validate();
      console.log("validate1=" + validate1);
      var message = "";

      if (validate1) {
        var form = {};

        let upload = new FormData();
        upload.append("UserInterface", 3);
        upload.append("Form", JSON.stringify(form));
        upload.append("uploadFile1", this.UploadedFile);

        console.log("upload=" + JSON.stringify(upload));

        this.SubmitFlag = true;
        this.ResultFlag = false;
        this.progessStart = 1;

        var server_url = companyConfig.apiURL;
        var token = this.$session.get("token");
        token = token == (null || undefined) ? 0 : token;
        var add_url = server_url + "api/lom-document/store";
        console.log(
          "server_url=" +
            server_url +
            ", token=" +
            token +
            ", add_url=" +
            add_url
        );

        console.log("upload=" + JSON.stringify(upload));

        const thisIns = this;
        var output = "";
        var flag = 0;

        this.$http({
          url: add_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: "Bearer " + token,
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
          .then(function (response) {
            console.log("response=" + JSON.stringify(response));

            thisIns.SubmitFlag = false;
            thisIns.progessStart = 0;

            output = response.data.output;
            flag = response.data.flag;
            console.log("output=" + output + ", flag=" + flag);

            if (flag == 1) {
              thisIns.ResultFlag = true;
              thisIns.sweetAlert("success", output, true);
              thisIns.closePrompt();
            } else {
              thisIns.sweetAlert("error", output, false);
            }
          })
          .catch(function (error) {
            console.log("error=" + error);
            thisIns.SubmitFlag = false;
            thisIns.progessStart = 0;
          });
      } else {
        var message = "";
        if (!validate1) {
          message += "Kindly fill required fields.";
        }
        if (!uploadFile1) {
          message += "File is not selected";
        }
        this.sweetAlert("error", message, false);
      }
    },
  },
  beforeMount() {
    this.refreshPageData();
    this.member = {};
  },
};
</script>
<style lang="scss" scoped>
#voting-rights {
  .upload-dialog-card {
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15);
  }

  .dialog-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 20px;
    background: linear-gradient(135deg, #3a67b1 0%, #2a4a8a 100%);
    color: white;
  }

  .header-content {
    display: flex;
    align-items: center;
    gap: 14px;
  }

  .header-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 42px;
    height: 42px;
    background: rgba(255, 255, 255, 0.2);
    border-radius: 10px;
  }

  .header-text {
    .header-title {
      font-size: 16px;
      font-weight: 600;
      margin: 0;
      color: white;
    }

    .header-subtitle {
      font-size: 12px;
      margin: 2px 0 0 0;
      opacity: 0.85;
    }
  }

  .close-btn {
    background: rgba(255, 255, 255, 0.15) !important;

    &:hover {
      background: rgba(255, 255, 255, 0.25) !important;
    }
  }

  .dialog-body {
    padding: 24px 20px;
    background: #f8fafc;
  }

  .sample-download-section {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 12px 16px;
    background: linear-gradient(
      135deg,
      rgba(58, 103, 177, 0.08) 0%,
      rgba(58, 103, 177, 0.04) 100%
    );
    border: 1px solid rgba(58, 103, 177, 0.2);
    border-radius: 8px;
    margin-bottom: 20px;

    .sample-text {
      font-size: 13px;
      color: #414042;
    }

    .sample-link {
      display: inline-flex;
      align-items: center;
      gap: 4px;
      font-size: 13px;
      font-weight: 600;
      color: #3a67b1;
      text-decoration: none;
      padding: 4px 10px;
      background: rgba(58, 103, 177, 0.1);
      border-radius: 4px;
      transition: all 0.2s ease;

      &:hover {
        background: rgba(58, 103, 177, 0.2);
      }
    }
  }

  .upload-section {
    margin-top: 8px;
  }

  .upload-dropzone {
    border: 2px dashed #cbd5e1;
    border-radius: 12px;
    padding: 32px 20px;
    text-align: center;
    cursor: pointer;
    transition: all 0.3s ease;
    background: white;

    &:hover {
      border-color: #3a67b1;
      background: rgba(58, 103, 177, 0.02);
    }

    &.has-file {
      border-style: solid;
      border-color: #4caf50;
      background: rgba(76, 175, 80, 0.04);
      padding: 16px 20px;
    }
  }

  .upload-placeholder {
    .upload-icon {
      margin-bottom: 12px;
    }

    .upload-text {
      font-size: 14px;
      font-weight: 600;
      color: #0a0f29;
      margin: 0 0 4px 0;
    }

    .upload-hint {
      font-size: 12px;
      color: #64748b;
      margin: 0;
    }
  }

  .file-preview {
    display: flex;
    align-items: center;
    gap: 14px;

    .file-icon {
      flex-shrink: 0;
    }

    .file-info {
      flex: 1;
      text-align: left;
      display: flex;
      flex-direction: column;
      gap: 2px;

      .file-name {
        font-size: 14px;
        font-weight: 600;
        color: #0a0f29;
        word-break: break-all;
      }

      .file-size {
        font-size: 12px;
        color: #64748b;
      }
    }

    .remove-file-btn {
      flex-shrink: 0;
    }
  }

  .hidden-file-input {
    position: absolute;
    opacity: 0;
    pointer-events: none;
    width: 0;
    height: 0;
  }

  .dialog-footer {
    padding: 16px 20px;
    background: white;
    border-top: 1px solid #e2e8f0;
  }

  .action-btn {
    padding: 0 20px !important;
    height: 38px !important;
    border-radius: 8px !important;
    font-weight: 600 !important;
    font-size: 13px !important;
    text-transform: none !important;
    letter-spacing: 0 !important;
    transition: all 0.2s ease !important;
  }

  .cancel-btn {
    background: #f1f5f9 !important;
    color: #475569 !important;

    &:hover {
      background: #e2e8f0 !important;
    }
  }

  .save-btn {
    background: linear-gradient(135deg, #3a67b1 0%, #2a4a8a 100%) !important;
    color: white !important;

    &:hover:not(:disabled) {
      box-shadow: 0 4px 12px rgba(58, 103, 177, 0.4);
    }

    &:disabled {
      background: #cbd5e1 !important;
      color: #94a3b8 !important;
    }
  }
}
</style>